import { useAuthStore } from '@/store/auth'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthCallback from '@/components/AuthCallback.vue'
import Layout from '@/layout/AppLayout.vue'
import ApiDocs from '@/pages/ApiDocs.vue'
import Calendar from '@/pages/Calendar.vue'
import CustomFields from '@/pages/CustomFields.vue'
import Maintenances from '@/pages/Maintenances.vue'
import NewReservation from '@/pages/NewReservation.vue'
import Resources from '@/pages/Resources.vue'
import UserGroups from '@/pages/UserGroups.vue'
import Users from '@/pages/Users.vue'
import i18n from '@/plugins/i18n'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        component: Layout,
        children: [
            { path: '/', name: 'calendar', component: Calendar, meta: { title: 'calendar.title' } },
            { path: '/new', name: 'new', component: NewReservation, meta: { title: 'calendar.new.title', roles: ['ManageInternalReservations', 'ManageOwnReservations'] } },
            { path: '/edit/:id', name: 'edit', component: NewReservation, meta: { title: 'calendar.edit.title', roles: ['ManageInternalReservations', 'ManageOwnReservations'] } },
            { path: '/resources', name: 'resources', component: Resources, meta: { title: 'resources.title', roles: ['ManageResources', 'ManageResourcesTimeSlots'] } },
            { path: '/maintenances', name: 'maintenances', component: Maintenances, meta: { title: 'maintenance.title', roles: ['ManageResourcesMaintainance'] } },
            { path: '/custom-fields', name: 'custom-fields', component: CustomFields, meta: { title: 'customFields.title', roles: ['ManageResources'] } },
            { path: '/users', name: 'users', component: Users, meta: { title: 'users.title', roles: ['ManageUsers'] } },
            { path: '/groups', name: 'groups', component: UserGroups, meta: { title: 'userGroups.title', roles: ['ManageGroups', 'ManageResourcesReferents'] } },
            { path: '/data-api', name: 'data-api', component: ApiDocs, meta: { title: 'dataApi.title', roles: [] } }
        ],
        meta: { requiresAuth: true }
    },
    { path: '/OAuth/OpenIdAuthorize', component: AuthCallback, name: 'oauth-callback', meta: { requiresAuth: false } }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()

    // ripristina sessione alla prima navigazione
    if (!authStore.user && !authStore.loading) {
        await authStore.restoreSession()
    }

    const requiresAuth = to.meta.requiresAuth !== false
    const isAuthCallback = to.name === "oauth-callback"

    // Se la route richiede autenticazione
    if (requiresAuth && !isAuthCallback) {
        if (!authStore.isAuthenticated) {
            authStore.loginRedirect()
            return false
        }

        // Se il token sta per scadere, prova a rifare il login
        if (authStore.isTokenExpiring) {
            console.warn("Token in scadenza, effettua un nuovo login")
            authStore.loginRedirect()
            return false
        }
    }

    // Controllo autorizzazioni
    const requiredRoles = to.meta.roles as string[] || []
    if (requiredRoles.length > 0) {
        const hasAuthorization = authStore.hasAnyAuthorization(requiredRoles)
        if (!hasAuthorization) {
            console.warn("Utente non autorizzato ad accedere a questa pagina")
            next({ name: 'calendar' })
            return false
        }
    }

    next()
})

router.afterEach((to) => {
    // Imposta il titolo della pagina
    const baseTitle = 'MC Booking Hub';

    if (to.meta.title) {
        const translatedTitle = i18n.global.t(to.meta.title as string);
        document.title = `${translatedTitle} - ${baseTitle}`;
    } else {
        document.title = baseTitle;
    }
});

export default router
